export default __webpack_public_path__ + "static/Pagarme_Integracao-75ecfec5b13996c33b30b95f0fc6bd6b.png";